import { render, staticRenderFns } from "./AnnouncementsTable.vue?vue&type=template&id=ad37d57a"
import script from "./AnnouncementsTable.vue?vue&type=script&lang=ts"
export * from "./AnnouncementsTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports